import { AxiosInstance } from "axios";
import { ICore } from "./interfaces";

export function getGradesBuilder(apiClient: AxiosInstance) {
  return async function getGrades(iso: string): Promise<ICore.IGrade[]> {
    const response = await apiClient.get("/grades/", {
      headers: {
        ...(iso && { "KZ-COUNTRY-ISO-CODE": iso }),
      },
    });
    return response.data;
  };
}
